import * as React from 'react';
import { InvoiceView, InvoiceViewProps } from './Invoice.view';

export type InvoiceControllerProps = InvoiceViewProps & {
  // ...
};

export const InvoiceController = (props: InvoiceControllerProps): JSX.Element => {
  const viewProps: InvoiceViewProps = { ...props };

  return <InvoiceView {...viewProps} />;
};
